(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6daf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6daf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("32QkI", function(module, exports) {
!function(o, e) {
    e(module.exports);
}(module.exports, function(o) {
    "use strict";
    const e = (o)=>{
        var e, n, r, t = "The Google Maps JavaScript API", a = "google", i = "importLibrary", s = "__ib__", p = document, c = window, l = c[a] || (c[a] = {}), d = l.maps || (l.maps = {}), m = new Set, g = new URLSearchParams;
        d[i] ? console.warn(t + " only loads once. Ignoring:", o) : d[i] = (c, ...l)=>m.add(c) && (e || (e = new Promise(async (i, c)=>{
                for(r in await (n = p.createElement("script")), g.set("libraries", [
                    ...m
                ] + ""), o)g.set(r.replace(/[A-Z]/g, (o)=>"_" + o[0].toLowerCase()), o[r]);
                g.set("callback", a + ".maps." + s), function(o, e) {
                    o.src = e;
                }(n, "https://maps.googleapis.com/maps/api/js?" + g), d[s] = i, n.onerror = ()=>e = c(Error(t + " could not load.")), n.nonce = p.querySelector("script[nonce]")?.nonce || "", p.head.append(n);
            }))).then(()=>d[i](c, ...l));
    };
    "production";
    "production";
    let n = !1;
    o.Loader = class {
        constructor(...o){
            throw new Error("[@googlemaps/js-api-loader]: The Loader class is no longer available in this version.\nPlease use the new functional API: setOptions() and importLibrary().\nFor more information, see the updated documentation at: https://github.com/googlemaps/js-api-loader/blob/main/README.md");
        }
    }, o.importLibrary = async function(o) {
        if (!window?.google?.maps?.importLibrary) throw new Error("google.maps.importLibrary is not installed.");
        return await google.maps.importLibrary(o);
    }, o.setOptions = function(o) {
        n ? ((o)=>{
            JSON.stringify(o);
        })(o) : (!function(o) {
            const n = Boolean(window.google?.maps?.importLibrary);
            n && ((o)=>{
                JSON.stringify(o);
            })(o);
            n || e(o);
        }(o), n = !0);
    };
}); //# sourceMappingURL=index.cjs.map

});


var $32QkI = parcelRequire("32QkI");
// Set the options for loading the API.
(0, $32QkI.setOptions)({
    key: "AIzaSyBP-Tpwni48KEKTGF3YaiWCjOupLT6vSf8"
});
const $040f67daa09e9fd3$var$initContactMaps = async (mapEls)=>{
    const { Map: Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement: AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    mapEls.forEach((el)=>{
        // Get zoom data attr
        const zoom = parseFloat(el.dataset.zoom);
        // Get lat and lng data attrs
        const { lat: lat } = el.dataset;
        const { lng: lng } = el.dataset;
        const latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };
        // Create gerenic map
        const mapArgs = {
            zoom: zoom || 16,
            center: latLng,
            mapId: 'cc814f174db119222c676c73',
            disableDefaultUI: true,
            backgroundColor: "#1F1414"
        };
        const map = new Map(el, mapArgs);
        // Create icon object. themeUrl set in enqueue.php with wp_localize
        const icon = document.createElement('img');
        icon.src = `${themeData.svgPath}lfs-marker.svg`;
        icon.classList.add('map-marker');
        // Create marker instance.
        const marker = new AdvancedMarkerElement({
            map: map,
            position: latLng,
            content: icon
        });
        setTimeout(()=>{
            el.classList.add('loaded');
        }, 400);
        // Return map instance.
        return map;
    });
};
var $040f67daa09e9fd3$export$2e2bcd8739ae039 = $040f67daa09e9fd3$var$initContactMaps;


const $580270ca595e650d$export$2e2bcd8739ae039 = ()=>{
    document.querySelectorAll('.wpcf7-list-item').forEach((item)=>{
        const input = item.querySelector('input[type="radio"], input[type="checkbox"]');
        if (input) item.addEventListener('click', (e)=>{
            if (e.target !== input) input.click();
        });
    });
    const applicationWrapper = document.querySelector('.application-question');
    if (!applicationWrapper) return;
    const triggers = applicationWrapper.dataset.showFor.split(',');
    const toggle = ()=>{
        const selected = document.querySelector('input[name="query-type"]:checked');
        const isMa = selected && triggers.includes(selected.value);
        applicationWrapper.style.display = isMa ? '' : 'none';
        applicationWrapper.querySelectorAll('input[name="application-submitted"]').forEach((input)=>{
            input.checked = false;
            input.removeAttribute('checked');
            // Set 'N/A' field to checked if not an MA option
            if (input.value === 'N/A' && !isMa) {
                input.checked = true;
                input.setAttribute('checked', '');
            }
        });
    };
    document.querySelectorAll('input[name="query-type"]').forEach((input)=>{
        input.addEventListener('change', toggle);
    });
    toggle();
};


const $f2945b94fc624c56$var$mapEls = document.querySelectorAll('.js-contact-map');
if ($f2945b94fc624c56$var$mapEls && $f2945b94fc624c56$var$mapEls.length > 0) (0, $040f67daa09e9fd3$export$2e2bcd8739ae039)($f2945b94fc624c56$var$mapEls);
const $f2945b94fc624c56$var$contactForm = document.querySelector('.js-contact-form');
if ($f2945b94fc624c56$var$contactForm) (0, $580270ca595e650d$export$2e2bcd8739ae039)($f2945b94fc624c56$var$contactForm);

})();
//# sourceMappingURL=contact.12c58e08.js.map
